import React from 'react';

export const StateRed: React.FC = () => (
  <>
    <div className="c-card__progress--dot c-card__progress--red" />
    <div className="c-card__progress--dot" />
    <div className="c-card__progress--dot" />
  </>
);
